module.exports = __webpack_public_path__ + "static/media/getrenk.b1a7dd2c.png";